import axios from "@/api/axios";

const getSchedule = (data) => {
    return axios
        .post('/admin/schedule', data)
        .then(response => response.data)
}

const getScheduleDuty = (data) => {
    return axios
        .post('/admin/schedule/duty', data)
        .then(response => response.data)
}

const getStaffSegments = (data) => {
    return axios
        .post('/admin/schedule/staff-segments', data)
        .then(response => response.data)
}

export default {
    getSchedule,
    getScheduleDuty,
    getStaffSegments
}